exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".insurance-products .breadcrumbs{margin:0 0 0 -25px;padding-left:27px}.insurance-products .main-product{margin-top:20px}.insurance-products .background-image-class{background-size:cover;background-position:center;height:229px;width:100%;overflow:hidden;border-radius:10px;box-shadow:0 .225rem .25rem rgba(0,0,0,.2);max-width:1250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ProductLanding/Products.scss
// module id = 7655
// module chunks = 101